import { ChangeEvent, ReactNode, useId } from 'react';

import { Column, ShortcutTag, SmartHTMLFileInput, Tooltip } from 'components/Blocks';
import { FilePlusIcon } from 'components/Icons';
import { cn } from 'styles';

interface FileIconInputButtonProps {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  className?: string;

  tooltip?: ReactNode;
  icon?: ReactNode;
  multiple?: boolean;
}

export function FileIconInput({
  onChange,
  className,
  icon,
  tooltip,
  multiple = true,
}: FileIconInputButtonProps) {
  const id = useId();

  return (
    <Tooltip
      content={
        tooltip ?? (
          <Column gap="1">
            <span>Add files...</span>
            <span className="text-xxs italic">
              You can also paste (<ShortcutTag keys={['ctrl', 'V']} className="text-xxs" />)
            </span>
          </Column>
        )
      }
    >
      <label
        htmlFor={id}
        className={cn(
          'flex cursor-pointer items-center justify-center rounded-full p-1 hover:bg-hover',
          className,
        )}
      >
        {icon ?? <FilePlusIcon size={14} />}

        <SmartHTMLFileInput id={id} multiple={multiple} className="hidden" onChange={onChange} />
      </label>
    </Tooltip>
  );
}
